/**
 * Whether the keyboard currently belongs to something being written in.
 *
 * The console's Meta-plane shortcuts are accelerators, and an accelerator must
 * not fire out from under a caret. Cmd+S is muscle memory for "save" and arming
 * the seat chord in a prompt box would eat the next digit out of the middle of a
 * sentence three seconds later; Cmd+M would maximise a pane behind the dialog
 * somebody is typing into. Same rule, two keys, one definition — the second
 * copy is where the two would start to disagree.
 *
 * **A terminal is deliberately not "writing".** xterm's own helper textarea is
 * where the keyboard sits whenever a pane has it, which is exactly when these
 * keys are most useful; treating it as a text field would disable the plane on
 * the screen it was built for.
 */
export function keyboardIsInAField(el: Element | null = document.activeElement): boolean {
  return (
    el instanceof HTMLElement &&
    !el.classList.contains('xterm-helper-textarea') &&
    el.matches('input, textarea, select, [contenteditable]')
  )
}
